export const DESCRIPTION =
    'Created by designers, our themes allow you to save time and get a visually optimal solution - the perfect combination of HD 4k wallpapers and widgets. Just choose the one that suits you best.';
